// src/providers/ConfirmModalProvider/ConfirmModalProvider.tsx
import { useState, useMemo, useCallback } from "react";

// src/state/confirmModal.ts
import { createContext } from "react";
var DEFAULT_CONFIRM_MODAL_VALUE = [
  Promise.resolve,
  {
    isModalOpen: false,
    modalHeader: "Are you sure?",
    modalBody: null,
    modalSize: "md",
    confirmText: "Confirm",
    cancelText: "Cancel",
    onConfirm: () => {
    },
    onCancel: () => {
    }
  }
];
var ConfirmModalContext = createContext(
  DEFAULT_CONFIRM_MODAL_VALUE
);
ConfirmModalContext.displayName = "ConfirmModalContext";
var confirmModal_default = ConfirmModalContext;

// src/providers/ConfirmModalProvider/ConfirmModalProvider.tsx
import { jsx } from "react/jsx-runtime";
var ConfirmModalProvider = ({
  children
}) => {
  const [state, setState] = useState(DEFAULT_CONFIRM_MODAL_VALUE[1]);
  const askConfirm = useCallback(
    (input) => new Promise((resolve, reject) => {
      setState({
        ...state,
        ...input,
        isModalOpen: true,
        onConfirm: () => {
          resolve(null);
          setState({
            ...state,
            isModalOpen: false
          });
        },
        onCancel: () => {
          reject();
          setState({
            ...state,
            isModalOpen: false
          });
        }
      });
    }),
    [state]
  );
  const value = useMemo(
    () => [askConfirm, state],
    [askConfirm, state]
  );
  return /* @__PURE__ */ jsx(confirmModal_default.Provider, { value, children });
};
var ConfirmModalProvider_default = ConfirmModalProvider;

// src/hooks/useConfirmModal.tsx
import { useContext } from "react";
var useConfirmModal = () => {
  const context = useContext(confirmModal_default);
  if (!context) {
    throw new Error(`useConfirm must be used within a ConfirmProvider`);
  }
  return context;
};
var useConfirmModal_default = useConfirmModal;
export {
  ConfirmModalProvider_default as ConfirmModalProvider,
  useConfirmModal_default as useConfirmModal
};
